import { useAuth } from "@trillion/auth";
import { SignInForm } from "@trillion/ui/components/sign-in-form";
import { Zap } from "lucide-react";

export function LoginPage() {
  const { loginWithPassport } = useAuth();

  return (
    <SignInForm
      title="Conduit Admin"
      description="Sign in with your Trillion Passport account"
      logo={
        <div className="flex size-12 items-center justify-center rounded-lg bg-primary text-primary-foreground">
          <Zap className="size-6" />
        </div>
      }
      showSsoButton
      onSsoClick={loginWithPassport}
      showLocalForm={false}
      onSubmit={async () => {}}
    />
  );
}
